export enum GroupTypeFilter {
	CUSTOM = 'custom',
	HIERARCHY_DERIEVED = 'hierarchyDerived'
}